module.exports = __webpack_public_path__ + "fonts/trellicons.467d7023fe591cbac8bc.woff";


//////////////////
// WEBPACK FOOTER
// ./resources/fonts/trellicons.woff
// module id = zePl
// module chunks = 13